import React, {useEffect, useState} from "react";
import useAxiosProtect from "../../../../../hooks/useAxiosProtect";
import {
  Line,
  Tooltip,
  CartesianGrid,
  XAxis,
  YAxis,
  ResponsiveContainer,
  ComposedChart,
  ReferenceLine
} from "recharts";

const AirLeakGraph = () => {

  const [graphData, setGraphData] = useState([]);
  const axiosProtect = useAxiosProtect();
  useEffect(() => {
          const controller = new AbortController();
          let site_id = parseInt(window.location.href.split('/').slice(-1));

          const getInfo = async () => {
            try {
                const response = await axiosProtect.get(`/r/raw-data/weekly-data-graph?id=${site_id}`, { signal: controller.signal });
                setGraphData([...response.data].reverse());
            } catch (err) {
                console.log(err);
            }
        }

        getInfo();

        return () => controller.abort();
  }, [])
  
  return (
    <div style={{ width: "100%", height: "400px" }}>
      <ResponsiveContainer>
        <ComposedChart data={graphData}>
          <CartesianGrid strokeDasharray="3 3" />

          <XAxis
            dataKey="week"
            label={{
              value: "Time (Weekly)",
              position: "insideBottom",
              offset: -5
            }}
          />

          <YAxis
            domain={([min, max]) => [Math.max(0, Math.floor(min - 5)), Math.ceil(max + 5)]}
            label={{
              value: "kW % of Leaks",
              angle: -90,
              position: "insideLeft"
            }}
          />

          <Tooltip />

          {/* 🔴 Dotted 45% Threshold Line */}
          <ReferenceLine
            y={45}
            stroke="#FF4D4F"
            strokeDasharray="6 6"
            strokeWidth={2}
            label={{
              value: "45% Threshold",
              position: "right",
              fill: "#FF4D4F",
              fontWeight: 600
            }}
          />

          <Line
            type="monotone"
            dataKey="leakPercent"
            stroke="#0872B6"
            strokeWidth={3}
            dot={{ r: 4 }}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default AirLeakGraph;
